<script setup lang="ts">
import FullImgShow from "./components/FullImgShow.vue";
import HiddenCommands from "./components/HiddenCommands.vue";
import Notifications from "./components/Notifications.vue";
import ProgrammingModal from "./components/ProgrammingModal.vue";
// import SettingModal from "./components/SettingModal.vue";
import DetailDialog from "./components/preview/DetailDialog.vue";
import { loadPage } from "./states/loadState";
import { settingModalState, viewState } from "./states/viewState.ts";
import { browserName, os, platform } from "./utils/platform.ts";
import LoadingView from "./views/LoadingView.vue";
import SettingModalNew from "./components/SettingModalNew.vue";
const alived = ["AdminCallsReport", "AdminStatistics", "AdminCallReport"];
</script>

<template>
  <div
    class="app-wrapper"
    :class="{
      [platform]: true,
      [os]: true,
      [browserName]: true,
    }"
  >
    <LoadingView v-if="loadPage" />
    <router-view v-else v-slot="{ Component, route }">
      <keep-alive :include="alived">
        <component :is="Component" :key="route.fullPath" />
      </keep-alive>
    </router-view>
    <!-- <SettingModal v-if="settingModalState" /> -->
    <SettingModalNew v-if="settingModalState" />
    <DetailDialog v-if="viewState.detailDialog" />
    <Notifications />
    <teleport to="body">
      <ProgrammingModal />
    </teleport>
    <FullImgShow />
    <HiddenCommands />
    <span class="font-with-emoji preload-emoji-font">😀</span>
  </div>
</template>

<style scoped>
.app-wrapper {
  height: 100%;
  width: 100%;
}
</style>
